import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { formatPeriodo } from 'src/app/utils/periodo.util';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';
import { Subscriber, Subscription } from 'rxjs';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { ModeloGraficaOpcion } from '../../graficas/grafica-modelo/grafica-modelo.component';

@Component({
  selector: 'app-lista-modelo',
  templateUrl: './lista-modelo.component.html',
  styleUrl: './lista-modelo.component.scss'
})
export class ListaModeloComponent implements OnInit {

  @Input() isPlanificador: boolean = false;
  @Input() fechaHoraSuscripcion: string = '';
  public listModelo = new CdkTableVirtualScrollDataSource<any>();
  public idCarteras: number[] = Array(100).fill(0);
  public idModelos: number[] = Array(100).fill(0);
  public idcarterasOptima: number[] = Array(100).fill(0);
  public nombreCarteras: string[] = [];
  public subIdCarteras: Subscription;
  @Input() isLoading: boolean=false;
  /*--------------------------*/
  @Output() cartera: EventEmitter<any> = new EventEmitter<any>();
  @Output() carterasOptima: EventEmitter<number[]> = new EventEmitter<number[]>();
  @Output() nombreCartera: EventEmitter<any> = new EventEmitter<any>();
  @Output() metaapiConflict: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectionMetaapi: EventEmitter<boolean | null> = new EventEmitter<boolean | null>();
  /** Modelos de las carteras seleccionadas, en orden de selección (combo "Modelo" de la gráfica embebida). */
  @Output() modelos: EventEmitter<ModeloGraficaOpcion[]> = new EventEmitter<ModeloGraficaOpcion[]>();
  private rowsMap: Map<number, any> = new Map();
  theme: string;
  licencia: string;
  loadinglistamodelo: boolean = false;
  constructor( private _sseservice: SseService,
                private _cookieService: CookieService,
                private _diversificadorsv: DiversificadorService,
                public dialog: MatDialog,
                private cdr: ChangeDetectorRef){}

  displayedColumns: string[] = ['fecharegistro','nombre','periodo','checkbox'];
  sortState: { active: string | null; direction: '' | 'asc' | 'desc' } = { active: null, direction: '' };
  private rawListaModelo: any[] = [];
  ngOnInit(): void {
    this.theme = localStorage.getItem('theme') || 'light-theme';
    this.licencia = this._cookieService.get('auth_token');
    if (this.isPlanificador){
      this.getListaCarteras();
    }
    this.subIdCarteras = this._diversificadorsv.valDivIdeCarteras$.subscribe({
      next: (data: any)=>{
        this.idCarteras = data;
      }
    });

  }

  formatPeriodo = formatPeriodo;

  onRowCheckboxChange(row: any) {
    const index = this.idCarteras.indexOf(row.idcartera);
    if (index !== -1) {
      // REMOVING a selected row
      this.idCarteras[index] = 0;
      this.idModelos[index] = 0;
      this.idcarterasOptima[index] = 0;
      this.nombreCarteras[index] = '';
      // this.iCarteras se debe desplazar para que los ceros se mantengan al final del array
      this.idCarteras.push(this.idCarteras.splice(index, 1)[0]);
      this.idModelos.push(this.idModelos.splice(index, 1)[0]);
      this.idcarterasOptima.push(this.idcarterasOptima.splice(index, 1)[0]);
      this.nombreCarteras.push(this.nombreCarteras.splice(index, 1)[0]);
      this.rowsMap.delete(row.idcartera);
      if (this.rowsMap.size === 0) {
        this.selectionMetaapi.emit(null);
      }
    } else {
      // ADDING — validate metaapi type compatibility
      const rowIsMetaapi: boolean = !!row.metaapi;
      if (this.rowsMap.size > 0) {
        const firstRow = this.rowsMap.values().next().value;
        const firstIsMetaapi: boolean = !!firstRow.metaapi;
        if (rowIsMetaapi !== firstIsMetaapi) {
          this.metaapiConflict.emit();
          this.cdr.detectChanges();
          return; // block selection — checkbox reverts via detectChanges
        }
      }
      const primerCeroIndex = this.idCarteras.indexOf(0);
      if (primerCeroIndex !== -1) {
        this.idCarteras[primerCeroIndex] = row.idcartera;
        this.idModelos[primerCeroIndex] = row.idmodelo;
        this.idcarterasOptima[primerCeroIndex] = row.idcarteraoptima;
        this.nombreCarteras[primerCeroIndex] = row.nombre;
        this.rowsMap.set(row.idcartera, row);
        if (this.rowsMap.size === 1) {
          this.selectionMetaapi.emit(rowIsMetaapi);
        }
      }
      this._diversificadorsv.updateDivIdCarteras(this.idCarteras);
      this._diversificadorsv.updateDivIdModelos(this.idModelos);
      this._diversificadorsv.updateDivIdCarterasOptima(this.idcarterasOptima);
    }
    let todosCeros: boolean = this.idCarteras.every(numero => numero === 0);
    if (todosCeros) {
      this._diversificadorsv.updateDivIdCarteras(this.idCarteras);
      this._diversificadorsv.updateDivIdModelos(this.idModelos);
      this._diversificadorsv.updateDivIdCarterasOptima(this.idcarterasOptima);
    }
    this.carterasOptima.emit(this.idcarterasOptima);
    this.cartera.emit(this.idCarteras);
    this.nombreCartera.emit(this.nombreCarteras);
    this.emitirModelos();
  }

  eliminarCartera(row: any) {
    console.log("ESTO SE VA A ELIMINAR: ", row);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '200px',
      panelClass: this.theme,
      data: {
        msj: '!Atención! La Cartera será eliminada en todos los módulos del programa Incluyendo Informes generados de la cartera.'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        const idcartera = {
          idcartera: Number(row.idcartera)
        };

        // Remove the portfolio from idCarteras if present
        const index = this.idCarteras.indexOf(row.idcartera);
        if (index !== -1) {
          this.idCarteras[index] = 0;
          this.idModelos[index] = 0;
          this.idcarterasOptima[index] = 0;
          this.nombreCarteras[index] = '';
          // Emit the updated arrays
          this.carterasOptima.emit(this.idcarterasOptima);
          this.cartera.emit(this.idCarteras);
          this.nombreCartera.emit(this.nombreCarteras);
          this.rowsMap.delete(row.idcartera);
          this.emitirModelos();
          // Update the diversificador service
          this._diversificadorsv.updateDivIdCarteras(this.idCarteras);
          this._diversificadorsv.updateDivIdModelos(this.idModelos);
          this._diversificadorsv.updateDivIdCarterasOptima(this.idcarterasOptima);

        }

        this._sseservice.apiPostNew('eliminarcartera', idcartera, this.licencia).subscribe(response => {
          console.log(response);
          this.getListaCarteras();
        });
      } else {
        console.log('La acción fue cancelada');
      }
    }); 
  }

  getListaCarteras(){
    this.loadinglistamodelo = true;
    this._sseservice.apiPostNew('listarcarteras',null, this.licencia ).subscribe(response => {
      let data = response;
      data = data.filter((item: { subCarteras: string; }) => item.subCarteras === "");
      this.rawListaModelo = data;
      this.applySortIfNeeded();
      console.log("listar diversificador: ",this.listModelo);

      // Pre-select rows that were set from URL params (idCarteras already populated via service)
      const preSelected = this.idCarteras.filter(id => id !== 0);
      if (preSelected.length > 0) {
        data.forEach((row: any) => {
          const slotIndex = this.idCarteras.indexOf(row.idcartera);
          if (slotIndex !== -1 && row.idcartera !== 0) {
            this.rowsMap.set(row.idcartera, row);
            this.idcarterasOptima[slotIndex] = row.idcarteraoptima;
            this.idModelos[slotIndex] = row.idmodelo;
            this.nombreCarteras[slotIndex] = row.nombre;
          }
        });
        if (this.rowsMap.size > 0) {
          const firstRow = this.rowsMap.values().next().value;
          this.selectionMetaapi.emit(!!firstRow.metaapi);
          this.carterasOptima.emit(this.idcarterasOptima);
          this.cartera.emit(this.idCarteras);
          this.nombreCartera.emit(this.nombreCarteras);
          this.emitirModelos();
        }
      }

      this.loadinglistamodelo = false;
    });
  }

  private emitirModelos(): void {
    // listarcarteras serializa Cartera.idModelo (Lombok) como "idModelo".
    this.modelos.emit(this.idCarteras
      .filter(id => id !== 0 && this.rowsMap.has(id))
      .map(id => {
        const row = this.rowsMap.get(id);
        return { idmodelo: Number(row.idModelo ?? row.idmodelo) || 0, nombre: row.nombre, idmercado: Number(row.idmercado) || 0 };
      })
      .filter(m => m.idmodelo > 0));
  }

  isIdSelected(id: number): boolean {
    return this.idCarteras.includes(id);
  }

  isDisabledByMetaapi(row: any): boolean {
    if (this.rowsMap.size === 0) return false;
    if (this.isIdSelected(row.idcartera)) return false;
    const firstRow = this.rowsMap.values().next().value;
    return !!row.metaapi !== !!firstRow.metaapi;
  }

  sortBy(columnId: string): void {
    if (this.sortState.active !== columnId) {
      this.sortState = { active: columnId, direction: 'asc' };
    } else {
      this.sortState.direction = this.sortState.direction === 'asc' ? 'desc' : this.sortState.direction === 'desc' ? 'asc' : '';
      if (!this.sortState.direction) this.sortState.active = null;
    }
    this.applySortIfNeeded();
  }

  private applySortIfNeeded(): void {
    const data = this.rawListaModelo;
    if (!this.sortState.active || !this.sortState.direction) {
      this.listModelo = new CdkTableVirtualScrollDataSource([...data]);
      return;
    }

    const col = this.sortState.active;
    const dir = this.sortState.direction === 'asc' ? 1 : -1;
    const isDate = col === 'fecharegistro';
    const isNumber = col === 'periodo';

    const sorted = [...data].sort((a, b) => {
      const vaRaw = a?.[col];
      const vbRaw = b?.[col];

      const va = isDate ? new Date(vaRaw).getTime() : isNumber ? Number(vaRaw) : (vaRaw ?? '').toString().toLowerCase();
      const vb = isDate ? new Date(vbRaw).getTime() : isNumber ? Number(vbRaw) : (vbRaw ?? '').toString().toLowerCase();

      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;

      if (va < vb) return -1 * dir;
      if (va > vb) return  1 * dir;
      return 0;
    });

    this.listModelo = new CdkTableVirtualScrollDataSource(sorted);
  }

}
